import { render, staticRenderFns } from "./ShippingManifestDestinationCorrectionForm.vue?vue&type=template&id=f0082270&scoped=true&"
import script from "./ShippingManifestDestinationCorrectionForm.vue?vue&type=script&lang=ts&"
export * from "./ShippingManifestDestinationCorrectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingManifestDestinationCorrectionForm.vue?vue&type=style&index=0&id=f0082270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0082270",
  null
  
)

export default component.exports